import { NestedValue } from "react-hook-form";
import _ from "lodash";

export interface TranscriptLine {
  speaker: string;
  text: string;
}

export interface Speaker {
  name: string | null;
  title: string | null;
}

export interface Topic {
  id: string;
  slug: string;
  name: string;
}

export interface Sector {
  sectorId: string;
  slug: string;
  name: string;
}

export interface Vendor {
  vendorId: string;
  slug: string;
  name: string;
}

export interface InsightsProductFormInput {
  name: string;
  description: string;
  previewDescription: string;
  publishDate: string;
  isActive: boolean;
  isFree: boolean;
  isForSale: boolean;
  isAvailable: boolean;
  transcriptLines: TranscriptLine[];
  files: string[];
  eventDetails: {
    date: string;
    time: string;
    location: string;
    address: string;
    type: string;
    description: string;
    speakers: Speaker[];
    organization: string;
    vendorsMentioned: string[];
    sectorsMentioned: string[];
    teaserQuotes: string[];
    signupUri?: string;
  };
  fileMap: FileMap;
  vendors: Vendor[];
  sectors: Sector[];
}

export type FileMapField = {
  name: string;
  file: File | null;
};

export interface FileMap {
  transcript: NestedValue<FileMapField> | null;
  abstract: NestedValue<FileMapField> | null;
  replay: NestedValue<FileMapField> | null;
  eventDeck: NestedValue<FileMapField> | null;
}

export type FileType = "transcript" | "abstract" | "replay" | "eventDeck";

export const parseTranscriptContent = (
  speakers: string[],
  content: string
): TranscriptLine[] => {
  if (!speakers.length)
    throw new Error("List of speakers required but speakers is empty.");

  const lines = content.split("\n");

  const transcriptLines: TranscriptLine[] = [];

  const appendNextLine = (line: string): void => {
    if (_.isEmpty(_.trim(line))) return;
    const lastIndex = transcriptLines.length - 1;
    transcriptLines[lastIndex].text += " " + _.trim(line);
  };

  for (const line of lines) {
    const regexp = new RegExp(
      `^(${speakers.map((s) => s + ":\\s+").join("|")})`
    );
    const match = line.match(regexp);
    const transcriptLine: TranscriptLine = { speaker: "", text: "" };
    if (match) {
      transcriptLine.speaker = match[1].replace(/:\s+/, "");
      transcriptLine.text = _.trim(match.input?.replace(regexp, ""));
      transcriptLines.push(transcriptLine);
    } else {
      appendNextLine(line);
    }
  }

  return transcriptLines;
};
